<template>
  <div class="doctorPage managerPlan Manager">
    <div class="selectSearch">
      <el-form ref="form" :model="hosParameter" class="qcFrom searchConditions" :inline="true">
        <el-form-item label="中心名称">
          <el-input v-model="hosParameter.name" class="name" placeholder="请输入中心名称" size="mini"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search" round>查询</el-button>
        </el-form-item>
        <a href="javascript:;" class="addbtn exportbtn" @click="showClick()">新建影像中心</a>
        <a href="javascript:;" class="addbtn marl10" @click="exportClick()">导出</a>
      </el-form>
    </div>
    <div class="centerHome">
      <div class="ccHomel">
        <div class="compentTable">
          <el-table
            class="qcTable scrollbar"
            :data="allHospitalsData.Hospitals"
            ref="multipleTable"
            v-loading="loading"
          >
            <el-table-column min-width="140" prop="ShortName" label="中心名称"></el-table-column>
            <el-table-column min-width="110" prop="HospitalName" label="机构全程"></el-table-column>
            <el-table-column prop="Level" label="等级">
              <template slot-scope="scope">
                <span>{{ scope.row.Level | transLevel }}</span>
              </template>
            </el-table-column>
            <el-table-column label="抽样方式(每位医生)">
              <template slot-scope="scope">
                <div v-if="scope.row.Type == 0">
                  未设置
                </div>
                <div v-else>
                  <span v-if="scope.row.Type == 1">按比例</span>
                  <span v-if="scope.row.Type == 2">按固定值</span>
                  <span>{{ scope.row.TypeValue }}</span>
                  <span v-if="scope.row.Type == 1">%</span>
                  <span v-if="scope.row.Type == 2">例</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="Enable" label="状态">
              <template slot-scope="scope">
                <span v-show="scope.row.Enable == 1">
                  启用
                </span>
                <span v-show="scope.row.Enable == 0">
                  禁用
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="操作" fixed="right" width="180">
              <template slot-scope="scope">
                <span class="table-task-btn detail" @click="showClick(scope.row)">编辑</span>
                <span class="table-task-btn detail" @click="staff(scope.row)">人员管理</span>
                <span class="table-task-btn delete" @click="delterClick(scope.row)">删除</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="pages">
            <el-pagination
              class="pageAll"
              align="center"
              layout="prev, pager, next"
              :total="allHospitalsData.TotalCount"
              :page-size="hosParameter.pageCount"
              :current-page="hosParameter.pageIndex"
              @current-change="currentChange"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "../../../api";
import axios from "@/js/api";
import { mapMutations, mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      hosParameter: {
        name: "",
        pageIndex: 1,
        pageCount: 10,
      },
      allHospitals: [],
      total: 0,
    };
  },
  computed: {
    ...Vuex.mapState("breadcrumb", ["loading", "allHospitalsData"]),
  },
  filters: {
    transLevel: function(val) {
      let newVal = "";
      switch (val) {
        case 0:
          newVal = "未分级";
          break;
        case 1:
          newVal = "一级";
          break;
        case 2:
          newVal = "二级";
          break;
        case 3:
          newVal = "三级";
          break;
      }
      return newVal;
    },
  },
  mounted() {},
  activated() {
    this.getAllHospitalsList();
  },
  methods: {
    ...Vuex.mapMutations("breadcrumb", ["setLoading"]),
    ...Vuex.mapActions("breadcrumb", ["getAllHospitals"]),
    exportClick() {
      window.open(axios.exportExcel(Api.api.manager.exportHospitals));
    },
    staff(row) {
      this.$router.push({
        path: "/home/plan/userManagement",
        query: {
          HospitalGuid: row.HospitalGuid,
        },
      });
    },
    // 编辑
    showClick() {
      let arg = arguments[0];
      let HospitalGuid = undefined;
      if (arg) {
        HospitalGuid = arg.HospitalGuid;
      }
      this.$router.push({
        path: "/home/manager/plan/editImageCore",
        query: {
          HospitalGuid: HospitalGuid,
        },
      });
    },
    // 删除
    delterClick(row) {
      let _this = this;
      this.$confirm("是否确定删除此中心信息？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.setLoading(true);
          row.IsDeleted = true;
          axios.ajaxPost("post", Api.api.manager.CreateOrUpdateHospital, row).then((res) => {
            _this.setLoading(false);
            if (res.data.StatusCode == 200) {
              this.$message.success("删除成功");
              _this.getAllHospitalsList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //获取列表接口
    getAllHospitalsList() {
      let _this = this;
      this.getAllHospitals({
        enable: -1,
        name: _this.hosParameter.name,
        pageIndex: _this.hosParameter.pageIndex,
        pageCount: 10,
      });
    },
    //分页
    currentChange(val) {
      this.hosParameter.pageIndex = val;
      this.getAllHospitalsList();
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    // 搜索
    search() {
      this.hosParameter.pageIndex = 1;
      this.getAllHospitalsList();
    },
  },
};
</script>

<style scoped="scoped">
.table-task-btn {
  width: 33%;
  text-align: center;
}
.exportbtn {
  right: 80px !important;
  background: #258afd !important;
}
</style>
